import React, { useState } from "react";
import {
  Box,
  Typography,
  Container,
  TextField,
  Button,
  Stepper,
  StepLabel,
  Step,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@mui/material";
import Header from "../../Home/Header";
import Footer from "../../Home/Footer";
import { useNavigate } from "react-router-dom";

export default function CreatePassword() {
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");

  const navigate = useNavigate();

  const steps = [
    "Mobile verification",
    "Profile Details",
    "Security Checkup",
    "Complete",
  ];

  const securityQuestions = [
    "What is your mother's maiden name?",
    "What was the name of your first school?",
    "What is your favorite movie?",
    "What city were you born in?",
    "What is your favorite food?",
  ];

  const handleCreateTPIN = () => {
    navigate("/registration/lowkyc/createtpin");
  };

  return (
    <>
      <Header />
      <Box sx={{ bgcolor: "#f5f7f6", p:6}}>
      <Box sx={{ bgcolor: "#f5f7f6", minHeight: "100vh" }}>
        <Container maxWidth="md">
          <Box
            sx={{
              bgcolor: "white",
              borderRadius: 3,
              boxShadow: "0 10px 25px rgba(0,0,0,0.08)",
              display: "flex",
              overflow: "hidden",
            }}
          >
            {/* Left Illustration */}
            <Box
              sx={{
                width: "40%",
                bgcolor: "#0aa34f",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                p: 4,
              }}
            >
              <Box
                component="img"
                src="/Assets/image.png"
                sx={{ width: "100%", maxWidth: 260 }}
              />
            </Box>

            {/* Right Content */}
            <Box sx={{ width: "60%", p: 5 }}>
              <Typography
                sx={{
                  cursor: "pointer",
                  mb: 2,
                  display: "inline-flex",
                  alignItems: "center",
                  color: "#3d7f45",
                  fontWeight: 500,
                  "&:hover": { textDecoration: "underline" },
                }}
                onClick={() => navigate("/registration/lowkyc/profiledetails")}
              >
                ← Back
              </Typography>

              {/* Stepper */}
              <Stepper activeStep={2} alternativeLabel>
                {steps.map((label) => (
                  <Step key={label}>
                    <StepLabel>{label}</StepLabel>
                  </Step>
                ))}
              </Stepper>

              <Typography
                variant="h5"
                fontWeight="bold"
                mt={4}
                mb={3}
                textAlign="center"
              >
               Create Password
              </Typography>

              <TextField
                label="Create Password"
                fullWidth
                sx={{ mb: 2 }}
               
                
              />

              <TextField
                label="Confirm Password"
                fullWidth
                sx={{ mb: 3 }}
               
              />


              <Button
                fullWidth
                sx={{
                  mt: 2,
                  bgcolor: "#0aa34f",
                  color: "white",
                  py: 1.5,
                  fontSize: 16,
                  "&:hover": { bgcolor: "#0aa34f" },
                }}
                variant="contained"
                onClick={handleCreateTPIN}
              >
                Create TPIN
              </Button>
            </Box>
          </Box>
        </Container>
      </Box>
      </Box>
      <Footer />
    </>
  );
}
